import { Stack, Typography } from "@mui/material";

import { useSubscriptionStatus } from "hooks";

export function ShipperPremiumLicenceSubscriptionDetail() {
  const { subscription } = useSubscriptionStatus();
  if (
    subscription?.subscription_plan === "SHIPPER_PREMIUM_LICENCE" &&
    subscription.shipper_premium_licence
  ) {
    return (
      <Stack
        id="shipper-premium-licence-container"
        direction="column"
        sx={{
          borderColor: "#cecdcd",
          borderWidth: "1px",
          borderStyle: "solid",
          borderRadius: 2,
          p: ".3rem",
          pl: ".5rem",
          mt: "1rem",
          mb: "1rem",
        }}
      >
        <Typography variant="h6">Shipper Premium Licence Details</Typography>
        <Typography>
          <b>{"Licences: "}</b>
          {subscription.shipper_premium_licence.total_licences}
        </Typography>
        <Typography>
          <b>{"Active Users/Seats: "}</b>
          {subscription.shipper_premium_licence.seats_used}
        </Typography>
        <Typography>
          Need more licences? Contact us through the chat icon in the bottom
          right corner.
        </Typography>
      </Stack>
    );
  }
  return null;
}
